import type { ToolUseRenderBlock } from "@/lib/chat-render";
import { StatusDot } from "@/components/common/StatusDot";
import { normalizeQuestions } from "@/components/hitl/user-choice/useUserChoice";
import { answerLabel, parseAnswers } from "./userChoiceAnswer";

// 他ブロック (本文・ツールカード) と同じくチャット列の左端から始める。
const CONTAINER_CLASS = "min-w-0";

function SingleChoiceCard({ tool }: { tool: ToolUseRenderBlock }) {
	const questions = normalizeQuestions(tool.input.questions);

	// tool.output は成功・エラーの両方で埋まるため、answered 判定は status で行う (isError を無視すると
	// 2 件目以降の HITL 拒否エラーを回答済みとして誤表示してしまう)。
	if (tool.status !== "completed") {
		// 中断は失敗ではないうえ、output は停止ファイナライザの内部マーカー ("[stopped] …") なので
		// そのまま出さない。
		if (tool.status === "cancelled") {
			return (
				<div className={`${CONTAINER_CLASS} flex items-center gap-1.5 text-ui text-fg-3`}>
					<StatusDot tone="muted" />
					<span>確認は停止されました。</span>
				</div>
			);
		}
		if (tool.status === "skipped") {
			return (
				<div className={`${CONTAINER_CLASS} flex items-center gap-1.5 text-ui text-fg-3`}>
					<StatusDot tone="muted" />
					<span>考察中</span>
				</div>
			);
		}
		if (tool.status === "error") {
			return (
				<div className={`${CONTAINER_CLASS} flex items-center gap-1.5 text-ui text-danger`}>
					<StatusDot tone="danger" />
					<span>{tool.output || "確認の取得に失敗しました。"}</span>
				</div>
			);
		}
		return (
			<div className={`${CONTAINER_CLASS} flex items-center gap-1.5 text-ui text-fg-3`}>
				<StatusDot tone="warning" />
				<span>確認を依頼中…</span>
			</div>
		);
	}

	const answers = parseAnswers(tool.output, questions.length);

	return (
		<div className={CONTAINER_CLASS}>
			<div
				data-testid="user-choice-answer"
				className="rounded-4 bg-surface-1 px-3 py-2.5 shadow-ring"
			>
				<div className="flex flex-col gap-3">
					{questions.map((q, i) => (
						<div key={i} className="flex flex-col gap-1 text-ui leading-snug">
							<span className="wrap-anywhere font-medium text-fg-1">{q.question}</span>
							<span className="wrap-anywhere text-fg-2">{answerLabel(q, answers[i])}</span>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}

/** request_user_choice ツールの回答結果を枠付きで表示する (トグルなし)。 */
export function UserChoiceCard({ tools }: { tools: ToolUseRenderBlock[] }) {
	return (
		<>
			{tools.map((tool) => (
				<SingleChoiceCard key={tool.key} tool={tool} />
			))}
		</>
	);
}
